/*
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-09-18 10:11:26
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-11-06 11:45:07
 * @FilePath: \合联\oms\src\base\common\topage.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
	activated() {
		if (this.$store.state.user.pageUrl) {
			console.log(this);
			if (!this.config) console.error('未配置 config, 查询失效')
			this.config.isGetList = true;
			this.$refs["table"].$refs[
				"header"
			].searchForm.keywords = this.$store.state.user.pageUrl;
			this.$store.state.user.pageUrl = "";
			this.$nextTick(() => {
				this.$refs["table"].getList();
			})
		}
	},
	mounted() {
		if (!this.$store.state.user.pageUrl) {
			this.$refs["table"].getList();
		}
	},
}